import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import { DateType } from '../../../static/types/commonTypes/dateType';
import DateComponent from '../../commonComponents/DateComponent';
import CompanyName from '../../commonComponents/CompanyName';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import LegalEntity from '../../commonComponents/LegalEntity';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { formatObjectText } from '../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const DissolutionSansLiquidation: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateDenomination,
    updateActiveIndex,
    societyType,
}) => {

    const {

        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        date, setDate,
        dateValidity, setDateValidity,
        dateChecked, setDateChecked,

        absorbedCompany, setAbsorbedCompany,
        absorbedCompanyValidity, setAbsorbedCompanyValidity,
        absorbedCompanyChecked, setAbsorbedCompanyChecked,

        absorbingCompany, setAbsorbingCompany,
        absorbingCompanyValidity, setAbsorbingCompanyValidity,
        absorbingCompanyChecked, setAbsorbingCompanyChecked,

        lastTab, setLastTab,

    } = useAppContext() as AppContextType

    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];
    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState<boolean>(false)

    const goToSupportPresse = () => updateActiveIndex(2);

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const tempText = `${absorbedCompany.companyName},
${absorbedCompany.legalForm} au capital de ${absorbedCompany.capital} €,
Siège social : ${absorbedCompany.address} ${absorbedCompany.additionalAddress ?? ""} ${absorbedCompany.postalCode} ${absorbedCompany.city}
${absorbedCompany.rcs} RCS de ${getCityWithPreposition(absorbedCompany.registrationOffice)},
Le ${date.date}, la société ${absorbingCompany.companyName}au capital de  ${absorbingCompany.capital} €, siège social : ${absorbingCompany.address} ${absorbingCompany.additionalAddress ?? ""} ${absorbingCompany.postalCode}, ${absorbingCompany.city} RCS de ${absorbingCompany.registrationOffice}, associé unique de la société ${absorbedCompany.companyName}, décidé la dissolution sans liquidation de cette société dans les conditions de l'article 1844-5 alinéa 3 du Code civil.
Les Créanciers peuvent former opposition devant le Tribunal de commerce ${absorbedCompany.registrationOffice} dans les 30 jours de la publication au Bodacc.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
        }
    };
    
    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive ( false )
    }
    
    const handleNext = () => {
        if (activeTab === 'companyName') {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if (activeTab === 'generalMeetingDate') {
            setDateChecked(true)
            if (dateValidity) {
                switchTab(getNextTab("generalMeetingDate"));
            }
        } else if (activeTab === 'absorbedCompany') {
            setAbsorbedCompanyChecked(true)
            if (absorbedCompanyValidity) {
                switchTab(getNextTab("absorbedCompany"));
            }
        } else if (activeTab === 'aborbingCompany') {
            setAbsorbingCompanyChecked(true)
            if (absorbingCompanyValidity) {
                setSubmissive(true)
            }
        }
    };

     
    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['companyName', 'generalMeetingDate', 'absorbedCompany', 'aborbingCompany' ];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    
    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);

    const getNextTab: any = (currentTab: string) => {
        if (currentTab === 'companyName') return 'generalMeetingDate';
        else if (currentTab === 'generalMeetingDate') return 'absorbedCompany';
        else if (currentTab === 'absorbedCompany') return 'aborbingCompany';
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === 'aborbingCompany') return 'absorbedCompany';
        else if (currentTab === 'absorbedCompany') return 'generalMeetingDate';
        else if (currentTab === 'generalMeetingDate') return 'companyName';
        else return currentTab;
    };

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName')
        }
        else if (!dateValidity) {
            setActiveTab('generalMeetingDate')
        }
        else if (!absorbedCompanyValidity) {
            setActiveTab('absorbedCompany');
        }
        else if (!absorbingCompanyValidity) {
            setActiveTab('aborbingCompany');
        }
        return companyNameValidity && dateValidity && absorbedCompanyValidity && absorbingCompanyValidity
    };

    const updateDate = (data: Partial<DateType>) => setDate({ ...date, ...data })
    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });
    const updateAbsorbedCompany = (data: Partial<LegalEntityType>) => setAbsorbedCompany({ ...absorbedCompany, ...data });
    const updateAbsorbingCompany = (data: Partial<LegalEntityType>) => setAbsorbingCompany({ ...absorbingCompany, ...data });

    const tabs = [
        {key: 'companyName', label: 'Raison Sociale' },
        {key:'generalMeetingDate', label: "Date de l'AG" },
        {key:'absorbedCompany', label: "La société Absorbé" },
        {key:'aborbingCompany', label: "La société Absorbante" }
    ]

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>

                {
                    activeTab === 'companyName' &&
                    <CompanyName
                        changeCompanyName={updateCompanyName}
                        companyName={companyName}
                        checked={companyNameChecked}
                        onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                    />
                }

                {
                    activeTab === 'generalMeetingDate' &&
                    <DateComponent
                        checked={dateChecked}
                        required={false}
                        date={date}
                        draftFieldName = 'date'
                        dateLabel="Date de la décision"
                        changeDate={updateDate}
                        onValidationChange={(isValid: boolean) => setDateValidity(isValid)}
                        id='dateGeneralMeeting'
                    />
                }

                {
                    activeTab === 'absorbedCompany' &&
                    < LegalEntity
                        checked={absorbedCompanyChecked}
                        legalEntity={absorbedCompany}
                        changeLegalEntity={updateAbsorbedCompany}
                        societyType={societyTypeOptions}
                        onValidationChange={(isValid: boolean) => setAbsorbedCompanyValidity(isValid)}
                        draftFieldName = 'absorbedCompany'
                    />
                }

                {
                    activeTab === 'aborbingCompany' &&
                    <>
                        < LegalEntity
                            checked={absorbingCompanyChecked}
                            legalEntity={absorbingCompany}
                            changeLegalEntity={updateAbsorbingCompany}
                            societyType={societyTypeOptions}
                            onValidationChange={(isValid: boolean) => setAbsorbingCompanyValidity(isValid)}
                            draftFieldName = 'absorbingCompany'
                        />
                        {
                            submissive &&
                            <div className="mt-4">
                                <h4>Texte de l'annonce:</h4>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    value={txtAnnonce}
                                    disabled
                                />
                            </div>
                        }
                    </>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious}
                            >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }
                        {
                            activeTab === 'aborbingCompany' &&
                            <button type="submit"
                                onClick={handleNext}
                            >
                                Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }
                        {
                            activeTab !== 'aborbingCompany' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext}
                            >
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }
                        {
                            submissive &&
                            activeTab === 'aborbingCompany' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse}
                            >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }
                    </div>
                </div>
            </form>
        </>
    );
};

export default DissolutionSansLiquidation;